export default "__VITE_ASSET__76effe2a__"